import { ErrorHandler, Injectable } from '@angular/core';
import { ToastService, ToastType } from '@motes-sdk';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
    constructor(private toastService: ToastService) { }

    handleError(error: any): void {
        // Handle the specific error of failed module loading
        if(error.message.includes('ChunkLoadError')) {
            const callback = () => window.location.reload();
            const label = $localize`A new version of StoryHunt creator is available, please reload to get the best user experience:`;
            this.toastService.addToast(label, ToastType.ERR, -1, true, {label: 'reload', callback});
        } else {
            // Delegate other errors to the default error handler
            console.error(error);
        }
    }
}
